import { Loader } from '@/components/Loader';
import { SeverityIndicator } from '@/components/SeverityIndicator';
import { useLeaderboardData } from '@/sections/customerManagement/hooks/data/useLeaderboardData';
import { RiskSeverity } from '@/types';

export function Leaderboard() {
  const { entries, status } = useLeaderboardData();

  if (status === 'pending') {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader isLoading type="spinner" />
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="flex h-full items-center justify-center">
        <p className="text-chariot-text-secondary text-sm">
          Failed to load leaderboard data.
        </p>
      </div>
    );
  }

  if (entries.length === 0) {
    return (
      <div className="flex h-full items-center justify-center">
        <p className="text-chariot-text-secondary text-sm">
          No leaderboard data available.
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-auto">
      <table
        aria-label="Praetorian leaderboard"
        className="w-full border-collapse text-sm"
      >
        <thead>
          <tr className="border-chariot-stroke border-b text-left">
            <th className="text-chariot-text-secondary px-4 py-3 font-medium">
              Rank
            </th>
            <th className="text-chariot-text-secondary px-4 py-3 font-medium">
              Praetorian
            </th>
            <th
              className="text-chariot-text-secondary px-4 py-3 font-medium"
              title="Includes Open, Closed, and Accepted risks"
            >
              Score
            </th>
            <th
              className="text-chariot-text-secondary px-4 py-3 text-center font-medium"
              title="Includes Open, Closed, and Accepted risks"
            >
              Critical
            </th>
            <th
              className="text-chariot-text-secondary px-4 py-3 text-center font-medium"
              title="Includes Open, Closed, and Accepted risks"
            >
              High
            </th>
            <th
              className="text-chariot-text-secondary px-4 py-3 text-center font-medium"
              title="Includes Open, Closed, and Accepted risks"
            >
              Medium
            </th>
            <th
              className="text-chariot-text-secondary px-4 py-3 text-center font-medium"
              title="Includes Open, Closed, and Accepted risks"
            >
              Low
            </th>
            <th
              className="text-chariot-text-secondary px-4 py-3 text-center font-medium"
              title="Includes Open, Closed, and Accepted risks"
            >
              Info
            </th>
          </tr>
        </thead>
        <tbody>
          {entries.map(entry => (
            <tr
              key={entry.email}
              className="border-chariot-stroke hover:bg-chariot-background-secondary border-b transition-colors"
            >
              <td className="text-chariot-text-secondary px-4 py-3">
                {entry.rank}
              </td>
              <td className="px-4 py-3">
                <div>
                  <span className="text-chariot-text-primary font-medium">
                    {entry.displayName}
                  </span>
                  <span className="text-chariot-text-secondary ml-2 text-xs">
                    {entry.email}
                  </span>
                </div>
              </td>
              <td className="text-chariot-text-primary px-4 py-3 font-semibold">
                {entry.score.toFixed(2)}
              </td>
              <td className="px-4 py-3 text-center">
                <SeverityIndicator
                  severity={RiskSeverity.Critical}
                  count={entry.counts[RiskSeverity.Critical]}
                  showZero
                  animate={false}
                />
              </td>
              <td className="px-4 py-3 text-center">
                <SeverityIndicator
                  severity={RiskSeverity.High}
                  count={entry.counts[RiskSeverity.High]}
                  showZero
                  animate={false}
                />
              </td>
              <td className="px-4 py-3 text-center">
                <SeverityIndicator
                  severity={RiskSeverity.Medium}
                  count={entry.counts[RiskSeverity.Medium]}
                  showZero
                  animate={false}
                />
              </td>
              <td className="px-4 py-3 text-center">
                <SeverityIndicator
                  severity={RiskSeverity.Low}
                  count={entry.counts[RiskSeverity.Low]}
                  showZero
                  animate={false}
                />
              </td>
              <td className="px-4 py-3 text-center">
                <SeverityIndicator
                  severity={RiskSeverity.Info}
                  count={entry.counts[RiskSeverity.Info]}
                  showZero
                  animate={false}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
